import { Path } from '@/main/router/routerPath';

import { NAME, CRUMB_LABEL_KEY } from './constants';
import List from './List.vue';
import Edit from './Edit.vue';

export const router = new Path(NAME, { List, Edit }, CRUMB_LABEL_KEY);
